import { render } from "./contact.vue?vue&type=template&id=79104cf2&scoped=true&ts=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"

import "./contact.vue?vue&type=style&index=0&id=79104cf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79104cf2"]])

export default __exports__